<ng-container *transloco="let t">
    <div class="flex flex-col w-full rounded-md">
        <!-- Header -->
        <p>
            <mat-toolbar class="bg-primary">
                <mat-toolbar-row>
                    @if(color() === 'success') {
                    <span class="text-white font-semibold">{{
                        t('modalNotification.success')
                    }}</span>
                    } @if(color() === 'info') {
                    <span class="text-white font-semibold">{{
                        t('modalNotification.info')
                    }}</span>
                    } @if(color() === 'warning') {
                    <span class="text-white font-semibold">{{
                        t('modalNotification.warning')
                    }}</span>
                    } @if(color() === 'error') {
                    <span class="text-white font-semibold">{{
                        t('modalNotification.error')
                    }}</span>
                    }
                    <span class="flex-auto"></span>
                    <a
                        mat-icon-button
                        [matTooltip]="t('modalNotification.close')"
                        (click)="close(true)"
                    >
                        <mat-icon class="text-white">close</mat-icon>
                    </a>
                </mat-toolbar-row>
            </mat-toolbar>
        </p>

        <div class="relative flex flex-col flex-auto items-start p-6 sm:p-12">
            <div class="w-full max-w-lg flex flex-col items-center gap-3">
                @switch (color()) { @case ("success") {
                <mat-icon
                    class="icon-size-20"
                    [ngClass]="iconClass() ?? 'text-success'"
                    >check_circle</mat-icon
                >
                } @case ("info") {
                <mat-icon
                    class="icon-size-20"
                    [ngClass]="iconClass() ?? 'text-info'"
                    >info</mat-icon
                >
                } @case ("warning") {
                <mat-icon
                    class="icon-size-20"
                    [ngClass]="iconClass() ?? 'text-warn'"
                    >report_problem</mat-icon
                >
                } @case ("error") {
                <mat-icon
                    class="icon-size-20"
                    [ngClass]="iconClass() ?? 'text-warn'"
                    >highlight_off</mat-icon
                >
                } }

                <h4 class="text-center">{{ message() | transloco }}</h4>
                @if (multiline(); as lines) { @if (lines.length) { @for (item of
                lines; track $index) {
                <p class="text-center w-full">{{ item }}</p>
                } } }
            </div>
        </div>

        <!-- Actions -->
        <div
            class="flex items-center justify-center px-6 sm:px-12 py-4 border-t bg-gray-50 dark:bg-transparent"
        >
            <button
                mat-flat-button
                [color]="'primary'"
                [matTooltip]="t('modalNotification.ok')"
                (click)="close({ data: true })"
            >
                {{ t('modalNotification.ok') }}
            </button>
        </div>
    </div>
</ng-container>
